// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__tZFGE","infoBtn":"quickbooks_infoBtn__2PbGA","formBox":"quickbooks_formBox__2tea4","formFooter":"quickbooks_formFooter__1xAFm"};